import {
  Typography,
  Button,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import { parse } from "json2csv";

import styles from "./App.module.css";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE,
  messagingSenderId: process.env.REACT_APP_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

// Initialize Firebase
if (firebase.apps.length === 0) {
  firebase.initializeApp(firebaseConfig);
}
const functions = firebase.functions();
const exportFunction = functions.httpsCallable("exportData");

// const exportWorkplanAsPDF = functions.httpsCallable("exportWorkplanAsPDF");

// TO ENABLE LOCAL FUNCTION
// functions.useEmulator("localhost", 5001);

const ACCEPTED_EMAILS = [
  "admin@workplanapp.com",
  "workplanapp@bbk.ac.uk",
  "jonnychallenger@gmail.com",
  "jonny@ingeniousonline.co.uk",
  "grunfeldrossini04@gmail.com",
];

function App() {
  const [isCheckingUser, setIsCheckingUser] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        setIsAuthenticated(true);
      } else {
        setIsAuthenticated(false);
      }
      setIsCheckingUser(false);
    });
  }, []);

  const signIn = (email, password) => {
    if (!ACCEPTED_EMAILS.includes(email))
      return window.alert("You are not authorised to access this page.");
    // admin@workplanapp.com
    // 12345678
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((userCredential) => {
        // var user = userCredential.user;
        setIsAuthenticated(true);
      })
      .catch((error) => {
        const errorMessage = error.message;
        console.error({ errorMessage });
        setIsAuthenticated(false);
      });
  };

  const onExportPress = async () => {
    setIsDownloading(true);
    exportFunction()
      .then((result) => {
        downloadCSV(result);
      })
      .catch((error) => {
        console.error(error);
        window.alert("Something went wrong:", error.message);
        setIsDownloading(false);
      });
  };

  const downloadCSV = (result) => {
    const CSV = createCSVFromJSON(result.data);

    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(CSV, "workplan-export");
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(CSV);
        link.setAttribute("href", url);
        link.setAttribute("download", "workplan-export");
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
    setIsDownloading(false);
  };

  const createCSVFromJSON = (data) => {
    const csv = parse(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    return blob;
  };

  // PDF Testing
  const onGetWorkplanPress = () => {
    // exportWorkplanAsPDF({ userId: "9Q7nc5hDg9U6MtQkly1VeAJp7VZ2" })
    //   .then((result) => {
    //     console.log({ result });
    //   })
    //   .catch((error) => {
    //     console.error(error);
    //     window.alert("Something went wrong:", error.message);
    //   });
  };

  if (isCheckingUser || isDownloading)
    return (
      <main className={styles.main}>
        <CircularProgress />
      </main>
    );

  return (
    <main className={styles.main}>
      {/* Temp Testing of PDF */}
      {/* <Button onClick={onGetWorkplanPress} variant="contained" color="primary">
        Create Workplan PDF
      </Button> */}

      <img src="https://workplan-bbk.web.app/logo-2.png" alt="Workplan" />
      {isAuthenticated ? (
        <Button onClick={onExportPress} variant="contained" color="primary">
          Export Data
        </Button>
      ) : (
        <SignIn signIn={signIn} />
      )}
    </main>
  );
}

export default App;

const SignIn = ({ signIn }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  return (
    <>
      <Typography variant="body1" gutterBottom={true}>
        Please sign in to export data
      </Typography>
      <TextField
        id="email"
        label="Email"
        type="email"
        required={true}
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <TextField
        id="password"
        label="Password"
        type="password"
        required={true}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <Button
        style={{ marginTop: "16px" }}
        variant="contained"
        color="secondary"
        onClick={() => signIn(email, password)}
      >
        Sign In
      </Button>
    </>
  );
};
